import { render, staticRenderFns } from "./addPests.vue?vue&type=template&id=5793f460"
import script from "./addPests.vue?vue&type=script&lang=js"
export * from "./addPests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports